<template>
  <v-app>
    <div class="d-flex justify-end">
      <img :src="require('./assets/logo.png')" class="mt-3 mr-3" height="100"/>
    </div>
    <v-main>
      <buchung/>
    </v-main>
  </v-app>
</template>

<script>
import buchung from './components/buchung';

export default {
  name: 'App',
  components: {
    buchung,
  },

  data: () => ({
    //
  }),
};
</script>
